import { Component, Input, Output, EventEmitter, AfterViewInit, SimpleChange, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements AfterViewInit {

  @Input() id: string;
  @Input() name: string;
  @Input() label?: string;
  @Input() value: number = 0;
  @Input() min: number = 0;
  @Input() max: number = 100;
  @Input() step: number = 1;
  @Input() showCurrency: boolean = true;
  @Input() showPercentage: boolean = false;
  @Input() percentageCalculatorValue: number = 100;
  @Input() disabled: boolean = false; // Add this line
  @Input() personalQuote: boolean = false;
  @Input() considerMax: boolean = false;

  @Output() onUpdate = new EventEmitter();
  @Output() onNext = new EventEmitter();

  dotValue = '1px';
  percentageValue = this.value / this.percentageCalculatorValue * 100;

  get percentageValue1() {
    return this.percentageValue;
  }

  constructor() {
    this.dotValue = (this.max / this.step) + 'px';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.value) {
      this.value = changes.value.currentValue;
      this.percentageValue = this.calculatePercentage(this.value);
    }
  }

  ngAfterViewInit() {
    this.createDots();
  }

  updateValue(event: any) {
    const numericValue = event.target.value.replace(/\D/g, '');
    const newValue = numericValue ? parseInt(numericValue, 10) : 0;
    if (this.considerMax && newValue > this.max) {
        return;
    }
    this.value = newValue;
    this.percentageValue = this.calculatePercentage(this.value);
    this.onUpdate.emit(this.value);
  }

  calculatePercentage(value: number): number {
    return parseFloat((+this.value / +this.percentageCalculatorValue * 100).toFixed(2)) || 0;
  }

  createDots() {
    const dotsContainer = document.getElementById(`dotsContainer-${this.id}`);
    if (dotsContainer) {
      dotsContainer.innerHTML = "";
      const numDots = (this.max - this.min) / this.step;

      for (let i = 0; i <= numDots; i++) {
        const dot = document.createElement("div");
        dot.innerHTML = '&nbsp;';
        dot.style.backgroundColor = i % 2 === 0 ? "#D9D9D9" : "#444";
        dot.style.width = "6px";
        dot.style.height = "6px";
        dot.style.borderRadius = "50%";
        dot.classList.add("dot");
        dotsContainer.appendChild(dot);
      }

    }
  }

  getPercentageValue() {
    return ((+this.value / +this.percentageCalculatorValue) * 100).toFixed(2)
  }

  onPercentageChange(event: any) {
    let percentage = +event.target.value;
    if (percentage > 75) {
      percentage = 75;
      event.target.value = this.percentageValue;
    }
    this.percentageValue = event.target.value;
    this.value = this.percentageValue * this.percentageCalculatorValue / 100;
    this.onUpdate.emit(this.value);
  }

  getSliderBackground = (controlName: string): string => {
    const percentage = ((this.value - this.min) / (this.max - this.min)) * 100 || 0;
    return `linear-gradient(to right, #ff4444 ${percentage}%, #e0e0e0 ${percentage}%)`;
  }

}
